/**
 * ids of sport market gametypes which need to be sorted
 * @TODO later we  need to automate this functionality, from cms it will be possible to modify this list
 */
export const sortedIds = [190, 100, 362, 12, -2964];
